import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "text-ellipsis",
  style: {"max-width":"112px"}
}
const _hoisted_2 = {
  class: "flex row items-center",
  style: {"width":"max-content"}
}
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 q-mb-md" }
const _hoisted_7 = { class: "additional-text q-mr-sm" }
const _hoisted_8 = { class: "col-12 q-mb-md" }
const _hoisted_9 = { class: "additional-text q-mr-sm" }
const _hoisted_10 = { class: "col-12 q-mb-md" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "additional-text q-mr-sm" }, "IP:", -1)
const _hoisted_12 = { class: "col-12 q-mb-md" }
const _hoisted_13 = { class: "additional-text q-mr-sm" }
const _hoisted_14 = {
  class: "flex row items-center",
  style: {"width":"max-content"}
}
const _hoisted_15 = ["alt", "src"]
const _hoisted_16 = { class: "col-6 q-mb-md" }
const _hoisted_17 = { class: "additional-text q-mr-sm" }
const _hoisted_18 = { class: "col-6 q-mb-md" }
const _hoisted_19 = { class: "additional-text q-mr-sm" }
const _hoisted_20 = { class: "col-6 q-mb-md" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text q-mr-sm" }, "OS:", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "col-6 q-mb-md" }
const _hoisted_25 = { class: "additional-text q-mr-sm" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "col-6 q-mb-md" }
const _hoisted_29 = { class: "additional-text q-mr-sm" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "col-6 q-mb-md" }
const _hoisted_33 = { class: "additional-text q-mr-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filters = _resolveComponent("Filters")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Filters, {
      onExport: _ctx.onExport,
      onReset: _ctx.resetFilters,
      onChange: _ctx.onChangeFilters,
      onChangeAll: _ctx.changeAll,
      "current-filters": _ctx.filters,
      tab: "clicks"
    }, null, 8, ["onExport", "onReset", "onChange", "onChangeAll", "current-filters"]),
    _createElementVNode("div", null, [
      _createVNode(_component_q_table, {
        rows: _ctx.rows,
        columns: _ctx.columns,
        "row-key": "id",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
        loading: _ctx.loading,
        onRequest: _ctx.onRequest,
        "binary-state-sort": "",
        flat: "",
        style: {"padding-top":"32px"},
        grid: _ctx.$q.screen.width <= 1199
      }, _createSlots({
        "body-cell-id": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(props.row.id), 1)
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-geoName": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  class: "q-mr-sm",
                  height: "10",
                  width: "15",
                  alt: props.row.geoIsoCode,
                  src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geoIsoCode}.svg`
              
                }, null, 8, _hoisted_3),
                _createTextVNode(" " + _toDisplayString(props.row.geoName), 1)
              ])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-offerName": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "flex",
                to: { name: 'offer', params: { id: props.row.offerId } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.offerName), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        _: 2
      }, [
        (_ctx.$q.screen.width <= 1199)
          ? {
              name: "item",
              fn: _withCtx((props) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('datetime')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.format(props.row.createdAt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('click_id')) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.id), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(props.row.ip), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('geo')) + ":", 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "q-mr-sm",
                          height: "10",
                          width: "15",
                          alt: props.row.geoIsoCode,
                          src: 
                    `http://purecatamphetamine.github.io/country-flag-icons/3x2/${props.row.geoIsoCode}.svg`
                  
                        }, null, 8, _hoisted_15),
                        _createTextVNode(" " + _toDisplayString(props.row.geoName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('offer')) + ":", 1),
                      _createVNode(_component_router_link, {
                        class: "flex",
                        to: { name: 'offer', params: { id: props.row.offerId } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.offerName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('campaign')) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.campaignName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      (props.row.os)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(props.row.os.trim()), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, "—"))
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('device')) + ":", 1),
                      (props.row.device)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(props.row.device.trim()), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_27, "—"))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('browser')) + ":", 1),
                      (props.row.browser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(props.row.browser.trim()), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, "—"))
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('campaign_url')) + ": ", 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.campaignUrl), 1)
                    ])
                  ])
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "grid"])
    ])
  ], 64))
}